module.exports = "/assets/data/0a085588890c576e18cdb9fea15c216c-RG9.data.json";